var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,0,0,2,16V44A14,14,0,0,0,16,58H44A14,14,0,0,0,58,44V16A14,14,0,0,0,44,2H16m0-2H44A16,16,0,0,1,60,16V44A16,16,0,0,1,44,60H16A16,16,0,0,1,0,44V16A16,16,0,0,1,16,0Z",
    fill: "#d9e1e7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,22a3,3,0,0,1-3-3V5A3,3,0,0,1,3,2H5V1A1,1,0,0,1,7,1V2h6V1a1,1,0,1,1,2,0V2h2a3,3,0,0,1,3,3V19a3,3,0,0,1-3,3ZM2,19a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V10H2ZM18,8V5a1,1,0,0,0-1-1H15V5a1,1,0,0,1-2,0V4H7V5A1,1,0,0,1,5,5V4H3A1,1,0,0,0,2,5V8Z",
    transform: "translate(20 18)",
    fill: "#809fb8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5d6d51fc5ad47be54a86e75e8679b8ff.svg";
export { ForwardRef as ReactComponent };